












































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi,
    parseFloatNumber
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalManualFactor from './ModalManualFactor.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { set } from 'tiny-cookie';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalManualFactor,
        DeleteConfirmation
    }
})
export default class UncalibratedAreaByDay extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    items: Array<object>;
    sortByTable: string[] = ['date'];
    sortDescTable: boolean[] = [true];
    headers: Array<object> = [
        {
            text: 'Fecha',
            value: 'date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Factor de calibración (%)',
            value: 'calibration_factor',
            align: 'center',
            formatter: this.parseNumber,
            sortable: true
        },
        {
            text: 'Factor de calibración Humedad (%)',
            value: 'humidity_calibration_factor',
            formatter: this.parseNumber,
            align: 'center',
            sortable: true
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: true,
            width: '80px'
        }
    ];

    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    dateFormatter(value) {
        return formattedDate(value);
    }

    parseNumber(value) {
        return parseFloatNumber(value);
    }

    formatBoolean(value) {
        return booleanFormatter(value);
    }
}
